const prefix = 'Rainmakers/RequisitionFilter/';

export const REQUISITION_DETAILS_LOAD_STARTED = `${prefix}REQUISITION_DETAILS_LOAD_STARTED`;
export const REQUISITION_DETAILS_LOAD_DONE = `${prefix}REQUISITION_DETAILS_LOAD_DONE`;
